import { defineMessages } from 'react-intl';

export const uploadDocumentModalMessages = defineMessages({
  modalTitle: {
    defaultMessage: 'Upload Documents',
    id: '69DEOJnkD0',
    description: 'Title of the library document upload dialog',
  },
  addingToCollection: {
    defaultMessage: 'Adding to: {name}',
    id: '9KdKXrtxCN',
    description:
      'Subtitle when uploading into a specific collection; name is the collection title',
  },
  closeButtonAria: {
    defaultMessage: 'Close',
    id: 'tQTfxa26dE',
    description: 'Aria label for closing the upload dialog',
  },
  removeFileAria: {
    defaultMessage: 'Remove file',
    id: 'K+GwCgdcJk',
    description: 'Aria label for removing a staged file from the upload list',
  },
  fileSizeMegabytes: {
    defaultMessage: '{size} MB',
    id: 'W2KPOR7vXx',
    description:
      'File size in megabytes after the numeric value; size is locale-formatted',
  },
  collectionNamePlaceholder: {
    defaultMessage: 'Collection name',
    id: 'HfHvkCUK/a',
    description: 'Placeholder for the inline new collection name field',
  },
  createAction: {
    defaultMessage: 'Create',
    id: 'D5X6T2g6My',
    description: 'Primary action to confirm creating a new collection',
  },
  cancelAction: {
    defaultMessage: 'Cancel',
    id: 'LFMtF4mhS9',
    description: 'Action to dismiss inline collection creation',
  },
  teamCollectionWithTeamName: {
    defaultMessage: 'Team Collection ({teamName})',
    id: 'bQOENkfeoj',
    description: 'Label for the team collection switch including the team display name',
  },
  visibleToTeamMembers: {
    defaultMessage: 'Visible to {teamName} members',
    id: 'B2z3WFSd1z',
    description: 'Tooltip or title explaining team visibility for a new collection',
  },
  addToCollectionLabel: {
    defaultMessage: 'Add to collection',
    id: 'NrbY0i7p/v',
    description: 'Label for the collection dropdown in the upload dialog',
  },
  selectCollectionPlaceholder: {
    defaultMessage: 'Select collection…',
    id: '2gv2qGWvtF',
    description: 'Placeholder when no collection is selected in the dropdown',
  },
  noCollectionOption: {
    defaultMessage: 'No collection',
    id: 'WjiqOXJBNj',
    description: 'Select option to upload without assigning a collection',
  },
  collectionDocumentCount: {
    defaultMessage: '{count, plural, one {# document} other {# documents}}',
    id: 'Xs+LAb2w/u',
    description: 'Document count shown next to a collection name in the upload dialog',
  },
  createNewCollectionOption: {
    defaultMessage: 'Create new collection',
    id: 'M3WIBKgfyO',
    description: 'Select option to switch to inline new collection creation',
  },
  collectionHelperSingleCollection: {
    defaultMessage:
      'Your document will be added to this collection. You can change this or create a new one.',
    id: '9lRpJzNIsF',
    description: 'Helper text when the user has only one collection to choose from',
  },
  uploadToLabel: {
    defaultMessage: 'Upload to',
    id: 'VWQOG7gb08',
    description: 'Label for choosing personal vs team upload scope',
  },
  personalScopeOption: {
    defaultMessage: 'Personal',
    id: '0p7jsvEbhE',
    description: 'Upload scope option for the current user’s library only',
  },
  teamAdminOnlyUploadTitle: {
    defaultMessage: 'Only team admins can upload to the team',
    id: 'OzJjCnLBlt',
    description: 'Tooltip on the disabled team scope option for non-admins',
  },
  teamAdminOnlyUploadHelper: {
    defaultMessage: 'Only team admins can upload to the team',
    id: 'cJdtJr3Vr6',
    description: 'Helper text when team upload is restricted for non-admins',
  },
  unsupportedFileType: {
    defaultMessage: 'Unsupported file type',
    id: 'pccZDsWyIe',
    description: 'Validation error when the file type is not allowed',
  },
  fileTooLarge: {
    defaultMessage: 'File too large. Max size: {size, number} MB',
    id: 'xa+sHCDiJw',
    description:
      'Validation error when the file exceeds the maximum size; size is the limit in MB',
  },
});
